// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1fnJb","title":"Header_title__26H2S"};